<template>
  <!--<div>-->
    <!--<v-layout>-->
      <v-flex d-flex>
        <v-card>
          <v-layout>
            <v-flex xs4 sm4>
              <div v-bind:style="stylePT">
              <v-img
                :src="image"
                height="105px"
                contain
              ></v-img>
              </div>
            </v-flex>
            <v-flex xs8 sm12>
              <v-card-title primary-title >
                <div>
                  <div class="headline">{{title}}</div>
                  <div class="mt-1"><span v-bind:style="styleOrange">{{price}}</span></div>
                  <div class="mt-1">{{descr}}</div>
                </div>
              </v-card-title>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    <!--</v-layout>-->
  <!--</div>-->
</template>

<script>
export default {
  name: 'insights-item',
  props: ['title', 'descr', 'image', 'price'],
  data () {
    return {
      styleOrange: {
        background: '#ff902b',
        color: '#ffffff',
        borderRadius: '.25em',
        padding: '.2em .6em .3em'
      },
      stylePT: {
        paddingTop: '15px'
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/insights-item/InsightsItem.vue